import { render, staticRenderFns } from "./BrickSettingsProperty.vue?vue&type=template&id=0609c773&"
import script from "./BrickSettingsProperty.vue?vue&type=script&lang=js&"
export * from "./BrickSettingsProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0609c773')) {
      api.createRecord('0609c773', component.options)
    } else {
      api.reload('0609c773', component.options)
    }
    module.hot.accept("./BrickSettingsProperty.vue?vue&type=template&id=0609c773&", function () {
      api.rerender('0609c773', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/BrickSettings/BrickSettingsProperty.vue"
export default component.exports